import { render, staticRenderFns } from "./TheMenuPrincipalListItem.vue?vue&type=template&id=087be41c&"
import script from "./TheMenuPrincipalListItem.vue?vue&type=script&lang=js&"
export * from "./TheMenuPrincipalListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports